module.exports = __webpack_public_path__ + "img/685ea58.png";